<app-modal-frame [headerText]="CONST.HEADER" (emitExit)="showWarningDialog()">
  <div class="new-security-screening-modal">
    <form
      [formGroup]="newSecurityScreeninForm"
      class="new-security-screening-modal-form"
    >
      <ion-row>
        <ion-col size="6" class="pr-col">
          <app-form-select
            [label]="CONST.SCREENING_TYPE"
            [options]="SCREENING_TYPE_OPTION"
            [placeholder]="CONST.SCREENING_TYPE"
            formControlName="screeningType"
            [hasRequiredSign]="true"
            (update)="clearFormValue()"
          >
          </app-form-select>
        </ion-col>
        <ion-col size="6" class="pl-col">
          <app-form-select
            [label]="CONST.SCREENING_METHOD"
            [options]="
              newSecurityScreeninForm.get('screeningType')?.value ===
              'COMM VERIF'
                ? COMMON_SCREENING_METHOD_OPTION
                : SCREENING_METHOD_OPTION
            "
            [placeholder]="CONST.SCREENING_METHOD"
            formControlName="screeningMethod"
            [hasRequiredSign]="true"
          >
          </app-form-select>
        </ion-col>

        <ion-col size="6" class="pr-col text-box-container">
          <app-form-input-field
            [label]="CONST.SCREENER_ID"
            [placeholder]="CONST.ENTER_ID"
            formControlName="screenerID"
            [required]="true"
            (keypress)="
              commonUtils.preventSpecialCharacters(
                $event,
                SpecialCharacters.ALPHABET_NUMBER
              )
            "
          ></app-form-input-field>
        </ion-col>
        <ion-col size="6" class="pl-col text-box-container">
          <app-form-input-field
            [label]="CONST.TRACKING_NUMBER"
            [placeholder]="CONST.ENTER_TRACKING_NUMBER"
            formControlName="trackingNumber"
            [required]="true"
            (keypress)="
              commonUtils.preventSpecialCharacters(
                $event,
                SpecialCharacters.ALPHABET_NUMBER
              )
            "
          ></app-form-input-field>
        </ion-col>

        <ion-col
          size="6"
          class="checkbox-container"
          [class.checkbox-disabled-container]="
            newSecurityScreeninForm.get('secondaryScreening')?.disabled
          "
        >
          <app-form-checkbox
            [label]="CONST.SECONDARY_SCREENING"
            formControlName="secondaryScreening"
          >
          </app-form-checkbox>
        </ion-col>
        <ion-col size="6" class="pl-col">
          @if (newSecurityScreeninForm.get("secondaryScreening")?.value) {
            <app-form-select
              [label]="CONST.SECONDARY_SCREENING_METHOD"
              [options]="SCREENING_METHOD_OPTION"
              [placeholder]="CONST.SECONDARY_SCREENING_METHOD"
              formControlName="secondaryScreeningMethod"
              [hasRequiredSign]="true"
            >
            </app-form-select>
          }
        </ion-col>

        <ion-col size="6" class="pr-col">
          <div class="form-group form-group-lg no-margin">
            <label class="big-label"
              >{{ CONST.SORT_DATE }} <span class="required-field">*</span>
            </label>
          </div>
          <app-form-date-picker
            [icon]="IMAGES.CALENDAR"
            [customClass]="'report-date-picker'"
            formControlName="sortDate"
            [minDate]="minDate"
            [maxDate]="maxDate"
          ></app-form-date-picker>
        </ion-col>
        <ion-col size="6" class="pl-col">
          <app-form-select
            [label]="CONST.SORT_CODE"
            [options]="SORT_CODE_OPTION"
            [placeholder]="CONST.SORT_CODE"
            formControlName="sortCode"
            [required]="true"
          >
          </app-form-select>
        </ion-col>
      </ion-row>

      <ion-row class="ion-justify-content-between">
        <ion-button
          class="cancel-btn"
          fill="outline"
          [buttonType]="'button'"
          (click)="showWarningDialog(true)"
        >
          {{ CONST.CANCEL }}
        </ion-button>
        <ion-button
          class="submit-btn"
          [disabled]="newSecurityScreeninForm.invalid"
          (click)="submitForm()"
        >
          {{ CONST.SUBMIT }}
        </ion-button>
      </ion-row>
    </form>
  </div>
</app-modal-frame>
